import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M10 19l-5-5h4.25L9.2426 1H10.75v13H15z'],
  height: 20,
  width: 20,
});
